import clsx from "clsx";
import { Subtitle } from "components/atoms/Text";

const ResidentialCard = ({ img, title, description, classNames, titleWidth, imageClassnames }) => {
    return (
        <div className="residential-cards w-full rounded-lg flex justify-between items-center flex-col md:flex-row p-6 pl-14 phone:p-4 phone:pb-5 tablet:pl-8 shadow-residentialCard">
            <div className={clsx(
                "w-full max-w-[499px]",
                classNames
            )}>
                <h1 className={clsx(
                    "font-semibold text-neutral-100 text-heading-3 tablet:text-heading-4 phone:text-heading-5 leading-[54px] tablet:leading-[42px] tracking-text-sm phone:pb-2 pb-4",
                    titleWidth
                )}>{title}</h1>
                <Subtitle classNames="phone:!tracking-normal !leading-[27.2px]">{description}</Subtitle>
            </div>
            <div className="w-[477px] phone:w-full phone:mt-6 phone:h-[229px] h-[374px] tablet:w-[359px] tablet:h-[320px] bg-primary-surface rounded-lg phone:px-[31px] px-10 py-[60px] flex items-center justify-center">
                <img src={img} width="100%" alt="dedicated" className={clsx(
                    "max-w-[318px] tablet:max-w-[296px] max-h-[265px] mx-auto",
                    imageClassnames
                )} />
            </div>
        </div>
    );
};

export default ResidentialCard;